import * as React from "react";
import * as TagPrisonUtil from "../uidispatcherapi/TagPrisonUtil";
import GtmEventsConsumer from "../uidispatcherapi/GtmEventsConsumer";
export class TagPrison extends React.Component<Record<PropertyKey, never>> {
	render() {
		const iframe = (
			<iframe
				sandbox="allow-scripts allow-same-origin"
				id="tagprison-iframe-id"
				src={TagPrisonUtil.getIFrameDomain(window)}
				style={{
					display: "none",
				}}
				ref={e => GtmEventsConsumer.setIframeRef(e)}
			/>
		);
		return TagPrisonUtil.showIFrame(window) ? iframe : null;
	}
}
